
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/customization/default-theme",
      function () {
        return require("private-next-pages/material-ui/customization/default-theme.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/customization/default-theme"])
      });
    }
  